@if (showFormSwitcherPanel) {
    <wdx-ff-version-info>
        <ng-container *ngTemplateOutlet="formVersionInfo"></ng-container>
    </wdx-ff-version-info>
}
@if (
    formDetails?.context?.activityExternalTask?.externalStatus ===
    ExternalTaskStatusType.Submitted
) {
    <wdx-alert themeColor="warning">{{
        FORM_EXTERNAL_USER_FORM_DATA_CHANGES
            | translateTokenisedString
                : {
                      dataName:
                          formDetails?.context?.externalFormSummary
                              ?.lastUpdatedByParty?.name || '',
                  }
    }}</wdx-alert>
}

@if (data && layoutDefinition) {
    <div
        ngbAccordion
        class="accordion accordion-widget"
        [ngClass]="{
            'sub-form': isSubForm,
        }"
        [destroyOnHide]="false"
        [closeOthers]="false"
        [animation]="false"
    >
        @for (
            formSectionLayoutDefinition of layoutDefinition?.sectionLayoutDefinitions;
            track formSectionLayoutDefinition.name;
            let i = $index
        ) {
            @if (!formSectionLayoutDefinition.isHidden) {
                <div
                    [ngbAccordionItem]="'panel-' + i"
                    [ngClass]="
                        layoutDefinition?.sectionLayoutDefinitions?.length === 1
                            ? 'form-section no-panel-toggle'
                            : 'form-section'
                    "
                    [collapsed]="!activeIds?.includes('panel-' + i)"
                >
                    <div ngbAccordionHeader>
                        @if (isSubForm) {
                            <button
                                ngbAccordionButton
                                type="button"
                                class="accordion-button d-flex p-2"
                            >
                                <div
                                    class="flex-grow-1 d-flex align-items-center"
                                >
                                    <wdx-ff-subform-info
                                        class="flex-grow-1"
                                        [entityId]="entityId"
                                        [fieldDefinition]="layoutDefinition"
                                        [sectionLayoutDefinitionName]="
                                            formSectionLayoutDefinition.name
                                        "
                                        [data]="data"
                                        [parentData]="parentData"
                                        [index]="i"
                                        [schema]="definition?.schema"
                                    >
                                    </wdx-ff-subform-info>
                                    @if (data?.addedOn) {
                                        <div class="flex-shrink-0 text-strong">
                                            {{
                                                TRANSLATION_FORM_CONTENT_ADDED_ON
                                                    | translateTokenisedString
                                            }}
                                            {{
                                                data?.addedOn
                                                    | formSummaryValue
                                                        : {
                                                              fieldType:
                                                                  FORM_FIELD_TYPE.Date,
                                                          }
                                                        : definition?.schema
                                                    | ngrxPush
                                            }}
                                        </div>
                                    }
                                    @if (pendingChangeAction) {
                                        <wdx-badge
                                            data-cy="subform-status-badge"
                                            themeColor="warning"
                                        >
                                            <wdx-icon
                                                [icon]="ICON_DANGER"
                                            ></wdx-icon>
                                            {{ pendingChangeAction }}
                                        </wdx-badge>
                                    }
                                </div>
                            </button>
                        }
                        @if (!isSubForm && formSectionLayoutDefinition.label) {
                            <button
                                ngbAccordionButton
                                class="form-section__header accordion-button d-flex align-items-center justify-content-between"
                                [attr.data-cy]="
                                    'panel-toggle-' +
                                    formSectionLayoutDefinition.name
                                "
                            >
                                <h5>
                                    {{
                                        formSectionLayoutDefinition.label
                                            | translateTokenisedString
                                    }}
                                </h5>
                            </button>
                        }
                    </div>
                    <div ngbAccordionCollapse>
                        <div
                            ngbAccordionBody
                            class="form overflow-hidden"
                            [attr.data-cy]="
                                'panel-' + formSectionLayoutDefinition.name
                            "
                        >
                            <div
                                class="grid"
                                [ngClass]="{
                                    'mt-2':
                                        isSubForm ||
                                        layoutDefinition
                                            ?.sectionLayoutDefinitions[0]
                                            ?.label,
                                    'mx-2': isSubForm,
                                }"
                            >
                                @for (
                                    element of formSectionLayoutDefinition.elementLayoutDefinitions;
                                    track element.name;
                                    let ii = $index
                                ) {
                                    @if (
                                        isSubForm &&
                                        subFormData[layoutDefinition.name]
                                    ) {
                                        @let pendingChanges =
                                            formSummaryPendingChangesService
                                                .subFormPendingChanges?.[
                                                layoutDefinition.name
                                            ]?.[subFormDataIndex]?.action
                                                ? formSummaryPendingChangesService
                                                      .subFormPendingChanges?.[
                                                      layoutDefinition.name
                                                  ]?.[subFormDataIndex]
                                                : formSummaryPendingChangesService
                                                      .subFormPendingChanges?.[
                                                      layoutDefinition.name
                                                  ]?.[subFormDataIndex]?.[
                                                      formSectionLayoutDefinition
                                                          .elementLayoutDefinitions[
                                                          ii
                                                      ]?.name
                                                  ];
                                        <ng-container
                                            *ngTemplateOutlet="
                                                elementTemplate;
                                                context: {
                                                    element:
                                                        subFormData[
                                                            layoutDefinition
                                                                .name
                                                        ][subFormDataIndex][ii],
                                                    pendingChanges:
                                                        pendingChanges,
                                                }
                                            "
                                        ></ng-container>
                                    }
                                    @if (!isSubForm) {
                                        <ng-container
                                            *ngTemplateOutlet="
                                                elementTemplate;
                                                context: {
                                                    element: element,
                                                }
                                            "
                                        ></ng-container>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
        }
    </div>
}

<ng-template
    #elementTemplate
    let-element="element"
    let-pendingChanges="pendingChanges"
>
    @if (element && !element.isHidden) {
        @if (element.forcesNewRow) {
            <div class="g-col-12"></div>
        }

        <div
            class="g-col-12 mb-2"
            [class.mb-5]="
                formDetails?.pendingChanges?.length ||
                PENDING_CHANGE_LOCK_ALL?.includes(pendingChanges?.action) ||
                pendingChanges?.[element.name]
            "
            [ngClass]="{
                'g-col-lg-6':
                    !element.forcesFullWidth &&
                    !ARRAY_SUMMARY_TYPES.includes(element.fieldType),
            }"
        >
            @if (ARRAY_SUMMARY_TYPES.includes(element.fieldType)) {
                <div
                    [attr.data-cy]="'content-' + element?.name"
                    [attr.data-cy-value]="data[element.name]?.length || 0"
                >
                    <h5 class="mb-3 no-wrap">
                        <span class="d-lg-inline fw-normal">
                            {{ element?.label | translateTokenisedString }}
                        </span>
                        <span
                            [attr.data-cy]="'quantity-amount-' + element?.name"
                            [attr.data-cy-value]="
                                data[element.name]?.length || '0'
                            "
                            >({{ data[element.name]?.length || '0' }})
                        </span>
                    </h5>

                    @for (
                        arrayData of data[element.name];
                        track $index;
                        let i = $index
                    ) {
                        <organism-form-summary-content
                            [entityId]="entityId"
                            [isSubForm]="true"
                            [data]="arrayData"
                            [parentData]="data"
                            [layoutDefinition]="element"
                            [definition]="definition"
                            [fieldIsRequiredInLayout]="
                                fieldIsRequiredInLayoutMap
                            "
                            [subFormData]="subFormData"
                            [subFormDataIndex]="i"
                        >
                        </organism-form-summary-content>
                    }
                </div>
            } @else {
                <ng-container [ngTemplateOutlet]="singleElement"></ng-container>
            }

            <ng-template #singleElement>
                @if (
                    element?.fieldType ||
                    element?.elementType === FormElementType.Field
                ) {
                    <molecule-summary-field
                        class="h-100"
                        [label]="element.label | translateTokenisedString"
                        [isRequired]="element.isRequired"
                        [isSensitive]="element.isSensitive"
                        [isPending]="
                            element.pendingChange ||
                            PENDING_CHANGE_LOCK_ALL?.includes(
                                pendingChanges?.action
                            ) ||
                            pendingChanges?.field === element.name
                        "
                        [cySelector]="'card-' + element.name"
                    >
                        @if (
                            data[element.name] !== undefined &&
                            data[element.name] !== null
                        ) {
                            @if (
                                !CUSTOM_SUMMARY_TYPES.includes(
                                    element.fieldType
                                )
                            ) {
                                <div>
                                    <ng-container
                                        [ngTemplateOutlet]="
                                            element.fieldType ===
                                            FORM_FIELD_TYPE.Multiselect
                                                ? standardArrayTemplate
                                                : standardSingleTemplate
                                        "
                                    >
                                    </ng-container>

                                    <ng-template #standardArrayTemplate>
                                        @for (
                                            item of data[element.name];
                                            track $index;
                                            let last = $last
                                        ) {
                                            <span
                                                [ngClass]="{
                                                    'divider--short divider-end':
                                                        !last,
                                                }"
                                            >
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                        standardTemplate;
                                                        context: {
                                                            item: item,
                                                        }
                                                    "
                                                >
                                                </ng-container
                                            ></span>
                                        }
                                    </ng-template>

                                    <ng-template #standardSingleTemplate>
                                        <ng-container
                                            *ngTemplateOutlet="
                                                standardTemplate;
                                                context: {
                                                    item: data[element.name],
                                                }
                                            "
                                        >
                                        </ng-container>
                                    </ng-template>

                                    <ng-template
                                        #standardTemplate
                                        let-item="item"
                                    >
                                        @if (
                                            element?.fieldType ===
                                            FORM_FIELD_TYPE.Duration
                                        ) {
                                            <div class="text-pre-line">
                                                {{
                                                    getDurationSummaryValue(
                                                        item
                                                    )
                                                }}
                                                {{
                                                    durationSummaryUnitToken
                                                        | translateTokenisedString
                                                }}
                                            </div>
                                        } @else if (
                                            element?.fieldType ===
                                            FORM_FIELD_TYPE.Boolean
                                        ) {
                                            <wdx-checkbox
                                                [disabled]="true"
                                                [checked]="item"
                                            ></wdx-checkbox>
                                        } @else {
                                            <div
                                                class="text-pre-line"
                                                [innerHtml]="
                                                    item
                                                        | formSummaryValue
                                                            : element
                                                            : definition?.schema
                                                        | ngrxPush
                                                "
                                            >
                                                @if (element?.prefix) {
                                                    {{ element.prefix }}
                                                }

                                                @if (element?.suffix) {
                                                    {{ element.suffix }}
                                                }
                                            </div>
                                        }
                                    </ng-template>
                                </div>
                            }
                            @if (
                                OPTIONS_SUMMARY_TYPES.includes(
                                    element.fieldType
                                )
                            ) {
                                <div
                                    class="d-flex align-items-center w-100 form-label mb-0"
                                >
                                    <ng-template
                                        #renderInnerHtml
                                        let-code="code"
                                    >
                                        <span
                                            [innerHtml]="
                                                code
                                                    | formSummaryValue
                                                        : element
                                                        : definition?.schema
                                                        : {
                                                              entityId:
                                                                  entityId,
                                                              formData: data,
                                                          }
                                                        : parentData
                                                    | ngrxPush
                                                    | translateTokenisedString
                                            "
                                        ></span>
                                    </ng-template>

                                    <ng-template #renderCountry let-code="code">
                                        @if (code) {
                                            <span
                                                class="d-inline-flex align-items-center me-2"
                                            >
                                                <span
                                                    class="flag flag-{{
                                                        code | lowercase
                                                    }} me-1"
                                                ></span>
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                        renderInnerHtml;
                                                        context: { code: code }
                                                    "
                                                ></ng-container>
                                            </span>
                                        }
                                    </ng-template>

                                    @if (
                                        element.selectSource ===
                                            SELECT_API_SOURCE.Country &&
                                            data[element?.name];
                                        as value
                                    ) {
                                        @if (value | isArray) {
                                            @for (item of value; track item) {
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                        renderCountry;
                                                        context: { code: item }
                                                    "
                                                ></ng-container>
                                            }
                                        } @else {
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    renderCountry;
                                                    context: { code: value }
                                                "
                                            ></ng-container>
                                        }
                                    } @else {
                                        <ng-container
                                            *ngTemplateOutlet="
                                                renderInnerHtml;
                                                context: {
                                                    code: data[element.name],
                                                }
                                            "
                                        ></ng-container>
                                    }
                                </div>
                            }

                            @if (
                                PHONE_SUMMARY_TYPES.includes(element.fieldType)
                            ) {
                                <div class="d-flex align-items-center w-100">
                                    <span
                                        class="flag flag-{{
                                            data[element.name].country
                                                | lowercase
                                        }} me-1"
                                    ></span>
                                    <span>
                                        {{
                                            data[element.name]
                                                | formSummaryValue
                                                    : element
                                                    : definition?.schema
                                                | ngrxPush
                                                | mask
                                                    : (data[element.name]
                                                          | telephonePattern
                                                          | ngrxPush)
                                        }}
                                    </span>
                                    <wdx-badge
                                        class="ms-auto me-2"
                                        themeColor="info"
                                    >
                                        {{
                                            data[element.name].type | titleCase
                                        }}
                                    </wdx-badge>
                                </div>
                            }

                            @if (
                                ADDRESS_SUMMARY_TYPES.includes(
                                    element.fieldType
                                )
                            ) {
                                @if (
                                    getDisplayAddress(data[element.name])
                                        | ngrxPush;
                                    as displayAddress
                                ) {
                                    <ng-container>
                                        <a
                                            [attr.href]="
                                                'https://www.google.com/maps/place/' +
                                                (displayAddress
                                                    | encodeURIComponent)
                                            "
                                            target="_blank"
                                            [innerHtml]="displayAddress"
                                        >
                                        </a>
                                    </ng-container>
                                }
                            }

                            @if (
                                TAGS_SUMMARY_TYPES.includes(element.fieldType)
                            ) {
                                @for (tag of data[element.name]; track $index) {
                                    <wdx-info-card
                                        class="d-inline-block me-1 mb-1"
                                        [flush]="true"
                                        [attr.data-cy]="
                                            'info-card-title-' + element.name
                                        "
                                    >
                                        <div wdxInfoCardLabel>{{ tag }}</div>
                                    </wdx-info-card>
                                }
                            }

                            @if (
                                LOOKUP_SUMMARY_TYPES.includes(element.fieldType)
                            ) {
                                @if (
                                    data[element.name]
                                        | asyncLookupAvatars
                                        | ngrxPush;
                                    as avatars
                                ) {
                                    <div>
                                        @if (avatars?.length > 0) {
                                            @for (
                                                avatar of avatars;
                                                track $index
                                            ) {
                                                <wdx-info-card
                                                    class="d-inline-flex me-1 mb-1 small"
                                                    [attr.data-cy]="
                                                        'info-card-title-' +
                                                        avatar.text
                                                    "
                                                >
                                                    <div wdxInfoCardLeading>
                                                        <molecule-avatar-group-container
                                                            size="sm"
                                                            [avatars]="[avatar]"
                                                        ></molecule-avatar-group-container>
                                                    </div>
                                                    <div wdxInfoCardLabel>
                                                        {{
                                                            avatar.text
                                                                | translateTokenisedString
                                                        }}
                                                    </div>
                                                    @if (avatar.lookupType) {
                                                        <div
                                                            wdxInfoCardAppendix
                                                        >
                                                            {{
                                                                avatar.lookupType
                                                                    | translateEntityType
                                                            }}
                                                        </div>
                                                    }
                                                </wdx-info-card>
                                            }
                                        } @else {
                                            <ng-container
                                                [ngTemplateOutlet]="noValue"
                                            ></ng-container>
                                        }
                                    </div>
                                }
                            }

                            @if (
                                FILE_SUMMARY_TYPES.includes(element.fieldType)
                            ) {
                                @for (
                                    file of data[element.name];
                                    track $index
                                ) {
                                    <wdx-document-info
                                        class="d-block mb-1"
                                        [fileIndex]="
                                            file?.fileIndex?.fileIndex
                                                ? file.fileIndex
                                                : file
                                        "
                                    >
                                    </wdx-document-info>
                                }
                            }

                            @if (
                                element.fieldType ===
                                FORM_FIELD_TYPE.DocumentLookup
                            ) {
                                @for (
                                    document of data[element.name];
                                    track $index
                                ) {
                                    <wdx-document-info
                                        class="d-block mb-1"
                                        [label]="document.name"
                                        [subtitle]="
                                            document.fileIndex | fileName
                                        "
                                        [fileIndex]="document?.fileIndex"
                                    >
                                    </wdx-document-info>
                                }
                            }

                            @if (
                                RICH_TEXT_SUMMARY_TYPES.includes(
                                    element.fieldType
                                )
                            ) {
                                <div
                                    [innerHtml]="
                                        data[element.name]
                                            | formSummaryValue
                                                : element
                                                : definition?.schema
                                            | ngrxPush
                                            | markdownToHtml
                                    "
                                ></div>
                            }

                            @if (
                                element.fieldType ===
                                    FORM_FIELD_TYPE.ImageUpload &&
                                (!data[element.name] ||
                                    data[element.name].length === 0)
                            ) {
                                <span>{{
                                    TRANSLATION_NO_FILE_UPLOADED
                                        | translateTokenisedString
                                }}</span>
                            }
                        } @else {
                            &nbsp;
                        }
                    </molecule-summary-field>
                } @else if (element?.elementType === FormElementType.Label) {
                    <molecule-summary-field
                        [label]="element.label | translateTokenisedString"
                        [labelOnly]="true"
                    ></molecule-summary-field>
                }
            </ng-template>
        </div>
    }
</ng-template>

<ng-template #formVersionInfo>
    <div>
        You are viewing a <strong>{{ formDetails.status }}</strong> version of
        this form (by
        <button
            class="btn btn-link"
            (click)="
                openLinkInNewTab(
                    formDetails?.context?.lastUpdatedBy?.partyType,
                    formDetails?.context?.lastUpdatedBy?.id
                )
            "
        >
            {{ formDetails?.lastUpdatedBy || 'unknown user' }}
        </button>
        ,

        {{ formDetails?.lastUpdatedOn | displayDate: { relative: true } }}) -

        <button class="btn btn-link" (click)="switchFormVersion()">
            Click here to view the
            {{
                formDetails.status === FORM_DATA_STATUS.Draft
                    ? 'previously saved'
                    : 'draft'
            }}
            version
        </button>
    </div>
</ng-template>
